import { on404 } from '@/decorators/on404';
import type { OwnOrganizationDTO } from '@/dto/organizations/OwnOrganization.dto';
import { pipeAsync } from '@/lib/functions';
import { makeBinded } from '@/proxies';
import { httpService } from '@/services/http.service';
import { administratorsEndpointsVO } from '@/vos/administrators/endpoints.vo';
import { httpHeadersVO } from '@/vos/http/headers.vo';
import type { Profile } from '@amministro-io-packages/auth-interfaces';

class AdministratorsRepository {
  private readonly _http = httpService;
  private readonly _endpoints = administratorsEndpointsVO;
  private readonly _headers = httpHeadersVO;

  @on404({ returnValue: null })
  async getOneEmailToTicket(profile: Profile): Promise<{ data: string | null }> {
    return this._http.aGet<string>(this._endpoints.findOneEmailToTicket({}), {
      headers: await pipeAsync(this._headers.autenticated, this._headers.json, this._headers.xAmministroProfile(profile))({}),
      throwHttpErrors: false,
    });
  }

  async getOrganization(profile: Profile, id: string) {
    return this._http.aGet<OwnOrganizationDTO>(this._endpoints.findOrganization({ id }), {
      headers: await pipeAsync(this._headers.autenticated, this._headers.json, this._headers.xAmministroProfile(profile))({}),
      throwHttpErrors: false,
    });
  }
}

const administratorsRepository = makeBinded(AdministratorsRepository);

export { administratorsRepository };
